var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTechReact(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_118_22)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50 59.3993C54.9225 59.3993 58.913 55.4088 58.913 50.4863C58.913 45.5637 54.9225 41.5732 50 41.5732C45.0774 41.5732 41.0869 45.5637 41.0869 50.4863C41.0869 55.4088 45.0774 59.3993 50 59.3993Z",
    fill: "#61DAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 68.7464C76.4136 68.7464 97.8261 60.5707 97.8261 50.4855C97.8261 40.4003 76.4136 32.2247 50 32.2247C23.5864 32.2247 2.17392 40.4003 2.17392 50.4855C2.17392 60.5707 23.5864 68.7464 50 68.7464Z",
    stroke: "#61DAFB",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1856 59.616C47.3924 82.4908 65.179 96.9467 73.913 91.9041C82.6471 86.8615 79.0212 64.23 65.8144 41.3551C52.6076 18.4802 34.821 4.02433 26.087 9.06693C17.3529 14.1095 20.9788 36.7411 34.1856 59.616Z",
    stroke: "#61DAFB",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1856 41.3551C20.9788 64.23 17.3529 86.8615 26.087 91.9041C34.821 96.9467 52.6076 82.4908 65.8144 59.616C79.0212 36.7411 82.6471 14.1095 73.913 9.06693C65.179 4.02432 47.3924 18.4802 34.1856 41.3551Z",
    stroke: "#61DAFB",
    strokeWidth: 4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_118_22"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 88.9716,
    fill: "white",
    transform: "translate(0 6)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechReact);
export default __webpack_public_path__ + "static/media/tech-react.9ef4fded48f44a31974ee42eff0e73a0.svg";
export { ForwardRef as ReactComponent };